export default __webpack_public_path__ + "static/media/linkedin.5cc7a168.png";